import { render, staticRenderFns } from "./IconPlay.vue?vue&type=template&id=3bd8a35c"
import script from "./IconPlay.vue?vue&type=script&lang=js"
export * from "./IconPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports